<template>
  <div class="container">
    <div v-if="(isindex && name) || !isindex">
      <h1 class="title_font2">
        {{ name == 'Products' && 
              pageData.pathName &&
              pageData.pathName.toUpperCase() === 'ALL'  ? $t("productList.products") : name }}
      </h1>
      <v-line></v-line>
      <div
        class="tinymce-content page_text_font default_css"
        v-if="description"
        v-html="description"
      ></div>
    </div>
    <div :class="filter_onoff ? 'filter_flex' : ''">
      <div
        class="col-md-3 d-none d-md-block"
        v-if="filter_onoff"
        :style="{
          padding: '0 20px',
          position: product_filter_fixed ? 'sticky' : 'static',
          top: product_filter_top + 50 + 'px',
        }"
      >
        <v-productFilter
          :product_filter="product_filter_res"
          :api_get_product="api_get_product"
        ></v-productFilter>
      </div>
      <div>
        <div
          class="d-block d-md-none"
          v-if="filter_onoff"
          style="margin-top: 10px"
        >
          <v-productFilter
            :product_filter="product_filter_res"
            :api_get_product="api_get_product"
          ></v-productFilter>
        </div>
        <div v-if="commoditylist.length">
          <v-commoditylistitem
            v-for="(item, index) in commoditylist"
            :key="index"
            :products="item"
            :collectionsslug="collectionsslug"
            :index="index"
            :layout="layout"
            model="is_card"
            :is_custom_button="is_custom_button"
            :palette_config="palette_config"
          ></v-commoditylistitem>
          <div
            class="paging"
            v-if="products_page.total / products_page.per_page > 1 && !isindex"
          >
            <el-pagination
              :small="small"
              :pager-count="5"
              :page-size="products_page.per_page-0"
              :current-page="products_page.current_page"
              layout="prev, pager, next"
              :total="products_page.total"
              @current-change="page"
            ></el-pagination>
          </div>
          <div style="text-align: center" v-if="isindex && category_path">
            <a
              :href="category_path"
              class="main_button text_font"
              style="
                padding: 10px 18px;
                display: inline-block;
                font-size: 19px;
                text-decoration: none;
              "
              v-cloak
              :class="[themeStyleRadius == 'circle' ? 'button-radius' : '']"
            >
              {{ $t("index.view_all") }}
            </a>
          </div>
        </div>
        <div class="page_text_font" v-else-if="!isindex">
          {{ $t("productList.no_products") }}
        </div>
        <v-noproduct v-else :layout="layout"></v-noproduct>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import mixFilter from "@/js/mixins/mixFilter";
import mixGetPlugs from "@/js/mixins/mixGetPlugs"
import { urlToQueryData } from '@/js/lib/util';

export default {
  props: [
    "products",
    "name",
    "collectionsslug",
    "isindex",
    "layout",
    "description",
    "category_path",
    "is_custom_button",
    "palette_config",
    "type",
    "product_filter",
    "product_tag",
  ],
  data() {
    return {
      commoditylist: [],
      small: false,
      products_list: [],
      products_ids: [],
      products_page: {},
      pageData: urlToQueryData(location.href),
    };
  },
  mixins: [mixFilter,mixGetPlugs],
  methods: {
    page(e) {
      window.open(this.replaceSearch("page", e), "_self");
    },
    ...mapActions({
      get_product_tag: "change_product_tag_list", // 将 `this.get_product_tag()` 映射为 `this.$store.dispatch('change_product_tag_list')`
      get_product_palette: "get_product_palette", //获取产品调色板
    }),
  },
  computed: {
    ...mapState({
      themeStyleRadius: ({ options }) => options?.theme?.global?.style?.type || "",
    })
  },
  mounted() {
    this.small = this.$(window).width() <= 575;
    if (this.product_tag) {
      this.get_product_tag(this.products_ids);
    }
    if (this.palette_config && this.type == "product_list") {
      this.get_product_palette(this.products_ids);
    }
  },
  beforeMount() {
    this.send_fb_event("ViewCategory", { content_name: this.name });
    if (this.products.data) {
      this.products_page = this.products;
    } else {
      this.products_list = this.products;
      let commoditylist_data = [];
      for (let i = 0; i < this.products_list.length; i += 3) {
        commoditylist_data.push(this.products_list.slice(i, i + 3));
      }
      this.commoditylist = commoditylist_data;
    }
    this.products_list.forEach((item) => {
      this.products_ids.push(item.ID);
    });
  },
  watch: {
    products_page: {
      handler(newV) {
        
        let { data } = newV;
        if (!data) {
          this.products_list = [];
          this.products_ids = [];
          return;
        }
        this.products_list = data;
        this.products_ids = [];
        data.forEach((item) => {
          this.products_ids.push(item.ID);
        });
        let commoditylist_data = [];
        for (let i = 0; i < this.products_list.length; i += 3) {
          commoditylist_data.push(this.products_list.slice(i, i + 3));
        }
        this.commoditylist = commoditylist_data;
        if (this.palette_config && this.type == "product_list") {
          this.get_product_palette(this.products_ids);
        }
        if (this.product_tag) {
          this.get_product_tag(this.products_ids);
        }
      },
      immediate: true,
    },
  },
};
</script>
<style scoped lang='scss'>
.container {
  text-align: center;
  margin: 80px auto 40px;
  h1 {
    margin-top: 16px;
    font-size: 26px;
    margin-bottom: 20px;
  }
  hr {
    height: 1px;
    display: block;
    margin: 0 auto 40px;
  }
}
@media screen and (min-width: 767px) {
  .filter_flex {
    display: flex;
    margin-right: -15px;
    margin-left: -15px;
    align-items: flex-start;
    & > div:last-child {
      flex: 1;
      max-width: 75%;
    }
  }
}
@media screen and (max-width: 768px) {
  .container {
    margin: 40px auto;
    hr {
      margin: 0 auto 20px;
    }
  }
}
</style>